
import React, { Component } from "react";
import { Configurations } from "../../../Utils/Configurations";
import './HighLights.scss';
import axios from 'axios';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import update from 'immutability-helper';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import HighLightsList from "../../../Components/HighLights-List/HighLights-List";
import Usuario from '../../../Utils/Usuario';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

class HighLights extends Component {

    constructor(props) {
        super(props);

        this.carregaDestaques = this.carregaDestaques.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.alteraPosicao = this.alteraPosicao.bind(this);
        this.mudaStatusDestaque = this.mudaStatusDestaque.bind(this);
        this.salvarAlteracoes = this.salvarAlteracoes.bind(this);
        this.toggleInativarDestaque = this.toggleInativarDestaque.bind(this);
        this.editarDestaque = this.editarDestaque.bind(this);
        this.verificaStatus = this.verificaStatus.bind(this);
        this.selecionarAba = this.selecionarAba.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            isLoadingDestaques: true,
            hasError: false,
            errorMessage: '',
            // listaDestaques: [],
            // nomeLista: [],
            modalInativarDestaque: false,
            isLoadingStatusDestaque: false,
            flagAlteracoes: {
                listaDestaquesBSMais: false,
                listaDestaquesHub: false
            },
            flagSucesso: {
                listaDestaquesBSMais: false,
                listaDestaquesHub: false,
            },
            abaSelecionada: '1',



        }


    }

    componentWillMount() {
        let _permissoes = [1, 4, 14, 20];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        if (!found) this.props.history.push({ pathname: '/permissao-negada' })
    }


    componentDidMount() {
        this.carregaDestaques();
    }

    carregaDestaques() {
        this.setState({ isLoadingDestaques: true });
        const _destaques = axios.get(this.Configurations.apiBasePath + `/destaques`);
        _destaques.then(response => {
            this.setState({
                listaDestaquesBSMais: response.data.destaquesBSMais,
                listaDestaquesHub: response.data.destaquesHub

            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingDestaques: false
        }));
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
        console.log(err);
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    alteraPosicao(indice, deslocamento, nomeLista) {
        this.setState({
            flagAlteracoes: update(this.state.flagAlteracoes, { [nomeLista]: { $set: true } }),
            flagSucesso: update(this.state.flagSucesso, { [nomeLista]: { $set: false } })
        })
        const podeSubir = indice !== 0 && deslocamento === -1;
        const podeDescer = indice !== (this.state[nomeLista].length - 1) && deslocamento === 1;

        if (podeSubir || podeDescer) {
            const card1 = this.state[nomeLista][indice];

            const card2 = this.state[nomeLista][indice + deslocamento];

            let listaAux = this.state[nomeLista];

            listaAux[indice] = card2;
            listaAux[indice + deslocamento] = card1;

            this.setState({
                [nomeLista]: []
            }, () => {
                this.setState({
                    [nomeLista]: listaAux
                })
            })
        }
    }

    verificaStatus(_index, nomeLista) {
        this.setState({
            flagAlteracoes: update(this.state.flagAlteracoes, { [nomeLista]: { $set: true } }),
            flagSucesso: update(this.state.flagSucesso, { [nomeLista]: { $set: false } })

        })
        if (this.state[nomeLista][_index].ativo) {
            this.toggleInativarDestaque(_index, nomeLista);
        } else {
            this.mudaStatusDestaque(_index, nomeLista);
        }
    }

    mudaStatusDestaque(_index, nomeLista) {
        this.setState({
            [nomeLista]: update(this.state[nomeLista], { [_index]: { ativo: { $set: !this.state[nomeLista][_index].ativo } } }),
            modalInativarDestaque: false
        })
    }

    salvarAlteracoes(nomeLista) {
        this.setState({ isLoadingDestaques: true })
        const novaListaDestaques = this.state[nomeLista].filter(destaque => destaque.ativo).map((item) => {
            return item._id
        })
        const plataforma = nomeLista === "listaDestaquesHub" ? 2 : 1;

        axios.post(this.Configurations.apiBasePath + `/destaques/atualizar-lista/${plataforma}`, { destaques: novaListaDestaques }).then(response => {
            this.setState({
                [nomeLista]: response.data.listaAtualizada,
                flagAlteracoes: update(this.state.flagAlteracoes, { [nomeLista]: { $set: false } }),
                flagSucesso: update(this.state.flagSucesso, { [nomeLista]: { $set: true } })
            })
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingDestaques: false
        }));
    }

    toggleInativarDestaque(_index, nomeLista) {
        this.setState({
            indexDesativar: _index, modalInativarDestaque: !this.state.modalInativarDestaque,
            nomeListaDesativar: nomeLista
        })
    }

    editarDestaque(item) {
        let _url;
        const {
            idVideoPrograma,
            idVideoEpisodio,
            idEpsodio,
            idPoadcast,
            idConteudo,
            idPublicidade,
            edicao
        } = item;
        switch (item.sigla.toLowerCase()) {
            case "bs": _url = `/conteudo/bs/${edicao}/${idConteudo}`; break;
            case "tc": _url = `/conteudo/tc/${edicao}/${idConteudo}`; break;
            case "rd": _url = `/conteudo/rd/${edicao}/${idConteudo}`; break;
            case "bm": _url = `/conteudo/bm/artigos/${idConteudo}`; break;
            case "juventude-soka": _url = `/conteudo/juventude-soka/${edicao}/${idConteudo}`; break;
            case "liga-monarca": _url = `/conteudo/liga-monarca/${edicao}/${idConteudo}`; break;
            case "gpv": _url = `/conteudo/gpv/${edicao}/${idConteudo}`; break;
            case "vd": _url = `/multimidia/videos/${idVideoPrograma}/${idVideoEpisodio}`; break;
            case "pd": _url = `/multimidia/podcasts/${idPoadcast}/${idEpsodio}`; break;
            case "pu": _url = `/publicidades/${idPublicidade}`; break;


            default: _url = ""; break;

        }
        return this.props.history.push(_url);
    }

    selecionarAba(tab) {
        this.setState({ abaSelecionada: tab })
    }

    render() {
        return (
            <div className="row px-0 px-lg-2 gerenciamento-destaques no-gutters">
                <div className="col-12">
                    <div className="row pt-3 border-bottom border-dark no-gutters pb-2">
                        <div className="col-12">
                            <h4 className="title-1">Gerenciamento de Destaques</h4>
                        </div>
                    </div>
                </div>
                {this.state.isLoadingDestaques ? (
                    <div className="col-12 text-center py-5">
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                ) : (
                    <div className="div-lista-destaques mt-3 border pb-4 w-100">
                        <Nav tabs>
                            <NavItem className="aba-bsmais text-center">
                                <NavLink className={this.state.abaSelecionada === '1' ? 'classe-ativada-bsmais' : 'classe-inativa'} onClick={() => { this.selecionarAba('1'); }}>
                                    BS+
                                </NavLink>
                            </NavItem>
                            <NavItem className="aba-hub text-center">
                                <NavLink className={this.state.abaSelecionada === '2' ? 'classe-ativada-hub' : 'classe-inativa'} onClick={() => { this.selecionarAba('2'); }}>
                                    HUB
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.abaSelecionada}>
                            <TabPane tabId="1">
                                <HighLightsList
                                    listaDestaques={this.state.listaDestaquesBSMais}
                                    renderizaCards={this.renderizaCards}
                                    editarDestaque={this.editarDestaque}
                                    alteraPosicao={this.alteraPosicao}
                                    verificaStatus={this.verificaStatus}
                                    flagAlteracoes={this.state.flagAlteracoes}
                                    flagSucesso={this.state.flagSucesso}
                                    salvarAlteracoes={this.salvarAlteracoes}
                                    nomeLista={"listaDestaquesBSMais"}
                                    abaSelecionada='1'
                                />
                            </TabPane>
                            <TabPane tabId="2">
                                <HighLightsList
                                    listaDestaques={this.state.listaDestaquesHub}
                                    renderizaCards={this.renderizaCards}
                                    editarDestaque={this.editarDestaque}
                                    alteraPosicao={this.alteraPosicao}
                                    verificaStatus={this.verificaStatus}
                                    flagAlteracoes={this.state.flagAlteracoes}
                                    flagSucesso={this.state.flagSucesso}
                                    salvarAlteracoes={this.salvarAlteracoes}
                                    nomeLista={"listaDestaquesHub"}
                                    abaSelecionada='2'
                                />
                            </TabPane>
                        </TabContent>
                    </div>

                )}
                <Modal isOpen={this.state.modalInativarDestaque} toggle={this.toggleInativarDestaque}>
                    <ModalHeader toggle={this.toggleInativarDestaque}>Mudança de Status do Destaque</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Deseja desativar este destaque?</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button disabled={this.state.isLoadingStatusDestaque} color="danger" onClick={() => this.mudaStatusDestaque(this.state.indexDesativar, this.state.nomeListaDesativar)}>confirmar</Button>
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalInativarDestaque: false })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </div>
        )
    }
}
export default HighLights;